import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '~/core/classes/auth/auth.guard';
import { AdminGuard } from '~/core/classes/auth/admin.guard';

//******************************************************************************
//  App Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';
import { UserDashboardComponent } from '~/pages/user-dashboard/user-dashboard.component';

export const routes: any[] = [
    {
        path: '',
        title: 'IntelENGINE',
        isNav: true,
        component: HomeComponent,
        canActivate: [AuthGuard],
        data: { tab: 'wells' }
    },
    {
        path: 'chat/:threadId',
        title: 'IntelENGINE',
        isNav: false,
        component: HomeComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'dashboard',
        title: 'IntelENGINE Dashboard',
        isNav: true,
        component: UserDashboardComponent,
        canActivate: [AuthGuard, AdminGuard],
        data: { hideRightNav: true }
    },
    {
        path: 'requests',
        title: 'Requests',
        icon: 'assignment',
        isNav: true,
        component: HomeComponent,
        canActivate: [AuthGuard],
        data: { tab: 'requests' }
    },
   
    {
        path: '**',
        redirectTo: 'notfound',
        pathMatch: 'full'
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRouting { }
